module.exports = __webpack_public_path__ + "LatoLatin-Semibold.b3831fa0a2596da983ef.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.ttf
// module chunks = styles